import React from "react";
import '../../App.css';


function Fotoproduk() {
    return (
      <div className="Foto">
        <img src="https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=398&q=80" alt="" />
      </div>
    );
  }

export default Fotoproduk
